<template>
  <div class="accepted-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Get quick and cheap car insurance quotes today! Cheapest rates as low as $19/mo+"
      button-text="Call an Agent"
    />

    <!-- Main Content Section -->
    <section class="quotes-section">
      <div class="container">
        <!-- Page Title -->
        <div class="quotes-header">
          <h1 class="quotes-title">Click at least TWO quotes to compare and save!</h1>
          <p class="quotes-subtitle">
            Asdf, shopping your options below gives you the highest chance of finding savings to put money back in your pocket.
          </p>
        </div>

        <!-- Quote Cards -->
        <div class="quotes-container">
          <!-- Progressive Quote Card - Recommended -->
          <div class="quote-card recommended">
            <div class="recommended-badge">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
              Recommended for you
            </div>
            
            <div class="quote-content">
              <div class="company-info">
                <div class="company-logo">
                  <img src="@/assets/images/ad1.gif" alt="Progressive" class="logo-img" />
                </div>
                <div class="company-details">
                  <h3 class="company-title">
                    Allstate Drivers who switch & Save w/ Progressive Save $920 on avg.
                  </h3>
                  
                  <div class="features-list">
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>Get a customized quote today and see what you could save</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>Fast, easy and reliable claims service available 24 hours a day</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>Trusted by millions of drivers to insure what's important</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="quote-action">
                <button class="view-quote-btn" @click="viewQuote('progressive')">
                  VIEW MY QUOTE
                </button>
              </div>
            </div>
          </div>

          <!-- Insurify Quote Card -->
          <div class="quote-card">
            <div class="quote-content">
              <div class="company-info">
                <div class="company-logo">
                  <img src="@/assets/images/ad2.gif" alt="Insurify" class="logo-img" />
                </div>
                <div class="company-details">
                  <h3 class="company-title">
                    Insurify® - Drivers Could Save Up To 50%
                  </h3>
                  
                  <div class="features-list">
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>★★★★★ 4.8 Star Rating - 2,300+ Positive Reviews</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>The easiest way to compare 20 real quotes from top brands</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>Prices starting from $29/mo</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>As seen on NBC, Fox News, ABC, Fortune Magazine</span>
                    </div>
                    <div class="feature-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="#28a745">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                      </svg>
                      <span>24/7 support - trusted by more than 21 million drivers</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="quote-action">
                <button class="view-quote-btn" @click="viewQuote('insurify')">
                  VIEW MY QUOTE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'AcceptedPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      userQuoteData: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有电话号码信息
          if (!this.userQuoteData.phone) {
            // 如果没有电话号码信息，跳转回get-quotes页面
            this.$router.push('/get-quotes')
            return
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    viewQuote(company) {
      console.log(`Viewing quote for ${company}`)
      
      // 记录用户点击的保险公司
      if (!this.userQuoteData.selected_quotes) {
        this.userQuoteData.selected_quotes = []
      }
      
      if (!this.userQuoteData.selected_quotes.includes(company)) {
        this.userQuoteData.selected_quotes.push(company)
        localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
      }
      
      // 跳转到Google
      window.open('https://www.google.com', '_blank')
    },
    
    goBack() {
      this.$router.push('/get-quotes')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.accepted-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main Content */
.quotes-section {
  flex: 1;
  padding: 3rem 0;
  background: #f8f9fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Header */
.quotes-header {
  text-align: center;
  margin-bottom: 3rem;
}

.quotes-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.quotes-subtitle {
  font-size: 1.1rem;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.5;
}

/* Quote Cards Container */
.quotes-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 900px;
  margin: 0 auto;
}

/* Quote Card */
.quote-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.quote-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.quote-card.recommended {
  border: 3px solid #28a745;
}

/* Recommended Badge */
.recommended-badge {
  background: #28a745;
  color: white;
  padding: 0.8rem 1.5rem;
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Quote Content */
.quote-content {
  padding: 2rem;
}

.company-info {
  display: flex;
  gap: 2rem;
  margin-bottom: 2rem;
}

.company-logo {
  flex-shrink: 0;
  width: 120px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.company-details {
  flex: 1;
}

.company-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1.5rem;
  line-height: 1.3;
}

/* Features List */
.features-list {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  font-size: 0.95rem;
  color: #555;
  line-height: 1.4;
}

.feature-item svg {
  margin-top: 0.1rem;
  flex-shrink: 0;
}

/* Quote Action */
.quote-action {
  text-align: center;
}

.view-quote-btn {
  background: #28a745;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 1rem 3rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  text-transform: uppercase;
}

.view-quote-btn:hover {
  background: #218838;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  .quotes-title {
    font-size: 1.8rem;
  }

  .quotes-subtitle {
    font-size: 1rem;
  }

  .quote-content {
    padding: 1.5rem;
  }

  .company-info {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .company-logo {
    width: 100%;
    height: 60px;
    justify-content: center;
  }

  .company-title {
    font-size: 1.1rem;
    text-align: center;
  }

  .features-list {
    text-align: left;
  }

  .feature-item {
    font-size: 0.9rem;
  }

  .view-quote-btn {
    width: 100%;
    max-width: 300px;
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .quotes-section {
    padding: 2rem 0;
  }

  .quotes-header {
    margin-bottom: 2rem;
  }

  .quotes-title {
    font-size: 1.5rem;
  }

  .quotes-subtitle {
    font-size: 0.9rem;
  }

  .quote-content {
    padding: 1rem;
  }

  .company-title {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .feature-item {
    font-size: 0.85rem;
    gap: 0.6rem;
  }

  .view-quote-btn {
    padding: 0.8rem 1.5rem;
    font-size: 0.9rem;
  }

  .recommended-badge {
    padding: 0.6rem 1rem;
    font-size: 0.8rem;
  }
}
</style>
